// extracted by mini-css-extract-plugin
export default {"container":"sJ-z","topReviewHeading":"tJ-z","criticalReview":"uJ-z","favorableReview":"vJ-z","vsSeparator":"wJ-z"};